<script setup>
import { Head, Link, useForm } from "@inertiajs/vue3";
import AuthenticationCard from "@/Components/AuthenticationCard.vue";
import InputError from "@/Components/InputError.vue";
import InputLabel from "@/Components/InputLabel.vue";
import PrimaryButton from "@/Components/PrimaryButton.vue";
import TextInput from "@/Components/TextInput.vue";
import ApplicationLogo from "@/Components/ApplicationLogo.vue";
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import Tooltip from "@/Components/Tooltip.vue";
import AuthLayout from "@/Layouts/AuthLayout.vue";

defineProps({
  canResetPassword: Boolean,
  status: String,
  lang: {}

});

const form = useForm({
  email: "",
  password: "",
  remember: false,
});

const submit = () => {
  form
    .transform((data) => ({
      ...data,
      remember: form.remember ? "on" : "",
    }))
    .post(route("login"), {

      onFinish: () => form.reset("password"),
    });
};

</script>

<template>
  <AuthLayout>

    <Head title="Log in" />
    <div class="login min-h-screen">
      <div class="block xl:grid md:grid  grid-cols-2 gap-4 ">
        <div class=" md:flex md:min-h-screen">
          <div class=" intro-x  md:my-auto md:mx-auto  mb-10  md:block hidden">
            <Link :href="route('home')">
            <ApplicationLogo class="xl:w-96 sm:w-48 sm:h-20 lg:h-44" />
            </Link>
            <div class="text-white  font-medium mt-10 xl:text-4xl sm:block hidden">
              Welcome to COI Center
            </div>
            <div class="mt-5 text-white text-lg sm:block hidden">
              The center where all your certificate needs are met.
            </div>

          </div>
        </div>
        <div class="md:h-screen pt-10 md:xl:h-auto md:flex md:py-5 md:xl:py-0 md:my-10 xl:my-0">
          <div
            class="my-auto mx-auto bg-white dark:bg-dark-1 xl:bg-transparent px-5 sm:px-8 py-8 xl:p-0 rounded-md shadow-md xl:shadow-none w-full md:w-3/4  xl:w-2/4">
            <div class=" flex">
              <h2 class=" font-bold text-2xl xl:text-3xl text-center xl:text-left">
                Sign In
              </h2>
              <div>
                <Tooltip>
                  <div class="">
                    To request Certificates of Insurance (COIs) at any time, day or night, please follow these simple
                    steps:
                  </div>
                  <div class="mt-1 flex">
                    <p class="font-bold mr-1">Log In:</p> Use the email address of your main contact to log in.
                  </div>
                  <div class="mt-1 flex-wrap ">
                    <span class="font-bold mr-1">Forgot Password: </span>If you don't remember your password, click
                    "forgot password" and follow the instructions to reset it.
                    <br>Following these steps will make it easier to renew, update, or remove any COI holder.
                  </div>
                </Tooltip>
              </div>
            </div>
            <AuthenticationCard>
              <form @submit.prevent="submit">
                <div class="mt-8">
                  <div v-if="status" class="mb-4 font-medium text-sm text-red-600">
                    {{ status }}


                  </div>
                  <InputLabel value="Username is your primary email" />
                  <span class="text-red-500 ml-1">*</span>
                  <TextInput id="email" v-model="form.email" type="email"
                    class=" login__input form-control py-3 px-4 border-gray-300 block" required autofocus
                    autocomplete="username" placeholder="Email" />
                  <InputError class="mt-2" :message="form.errors.email" />
                </div>

                <div class="mt-4">
                  <InputLabel for="password" value="Password" />
                  <span class="text-red-500 ml-1">*</span>
                  <TextInput id="password" v-model="form.password" type="password"
                    class="login__input form-control py-3 px-4 border-gray-300 block" required
                    autocomplete="current-password" placeholder="Password" />
                  <InputError class="mt-2" :message="form.errors.password" />
                </div>
                <div class="flex items-center justify-end mt-4">
                  <Link v-if="canResetPassword" :href="route('password.request')"
                    class=" font-bold underline text-sm text-gray-600 hover:text-gray-900 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                  First-time login OR Forgot password? Click here
                  </Link>
                </div>
                <div class="text-center">
                  <PrimaryButton class="mt-6 w-full" :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing">
                    Log in
                  </PrimaryButton>
                  <div class="flex justify-end mt-4">
                    Not Registered?
                    <Link :href="route('register')"
                      class="underline text-sm text-shade4 hover:text-gray-900 rounded-md focus:outline-none ml-1">
                    Sign up
                    </Link>
                  </div>
                </div>
              </form>
            </AuthenticationCard>
            <!-- <div
              class="intro-x xl:mt-24 text-gray-700 dark:text-gray-600 text-center xl:text-left"
            >
              By signin in, you agree to our
              <br />
              <a class="text-theme-1 dark:text-theme-10" href=""
                >Terms and Conditions
              </a>
              &
              <a class="text-theme-1 dark:text-theme-10" href=""
                >Privacy Policy</a
              >
            </div> -->
          </div>
        </div>
        <div class="md:my-auto md:mx-auto md:mt-10 mb-10 pt-10 md:hidden">
          <a class="intro-x" :href="route('home')">
            <ApplicationLogo class="xl:w-96 sm:w-48 sm:h-20 lg:h-48  mx-auto" />
          </a>
          <div class=" intro-x text-white text-center font-medium mt-10  xl:text-4xl md:hidden">
            Welcome to COI Center
          </div>
          <div class="intro-x  text-center mt-5 text-white text-lg md:hidden">
            The center where all your certificate needs are met.
          </div>

        </div>
      </div>
    </div>
  </AuthLayout>
</template>
